import { NpoPlayerEvent } from '../../types/events';
export function processNicam(playerContext, nicamElement) {
    const streamOptions = playerContext.npoplayer.streamOptions;
    const metadata = playerContext?.npoplayer?.streamObject?.metadata ?? {};
    const effectiveMetadata = { ...metadata, ...streamOptions };
    if (nicamElement) {
        nicamElement.innerHTML = '';
        if (effectiveMetadata.ageRating !== undefined && isNicamIconValid(effectiveMetadata.ageRating.toLowerCase())) {
            addNicamIcon(effectiveMetadata.ageRating.toLowerCase(), nicamElement);
        }
        if (effectiveMetadata.nicam) {
            for (const character of effectiveMetadata.nicam) {
                const lowerCaseCharacter = character.toLowerCase().replace(/ /g, '_');
                if (isNicamIconValid(lowerCaseCharacter)) {
                    addNicamIcon(lowerCaseCharacter, nicamElement);
                }
            }
        }
    }
}
function isNicamIconValid(icon) {
    const validIcons = [
        'angst',
        'discriminatie',
        'geweld',
        'drugs_en_alcohol',
        'grof_taalgebruik',
        'seks',
        '6',
        '9',
        '14',
        '12',
        '16',
        '18',
        'all',
        'all_tous',
        'tous',
        'not_yet_rated'
    ];
    return validIcons.includes(icon);
}
export function addNicamIcon(character, nicamElement) {
    const iconClass = `nicam-icon-${character.toLowerCase()}`;
    const span = document.createElement('span');
    span.classList.add('nicam-icon', iconClass);
    nicamElement.appendChild(span);
}
export function showNicamAfterUiDelay(playerContext, uiManager) {
    const player = playerContext.player;
    player.off(NpoPlayerEvent.Play, () => {
        showNicamAfterUiDelay(playerContext, uiManager);
    });
    if (uiManager === null)
        return;
    const playerContainer = player.getContainer().querySelector('.bmpui-npo-player.bmpui-layout-max-width-400') ||
        player.getContainer().querySelector('.bmpui-npo-player.bmpui-layout-max-width-600');
    if (!playerContainer)
        return;
    uiManager?.activeUi.onControlsHide.subscribeOnce(() => {
        const className = 'bmpui-show-nicam';
        playerContainer.classList.add(className);
        setTimeout(() => {
            playerContainer.classList.remove(className);
        }, 3000);
    });
}
export function setupNicamKijkwijzerIcons(playerContext) {
    const { container } = playerContext.npoplayer;
    const nicamElement = container.querySelector('.bmpui-nicam');
    processNicam(playerContext, nicamElement);
}
